import InfoPopoverComponent from './info-popover.component'

const InfoPopoverModule = angular.module('cdbl.info-popover', [

])
  .component('cdblInfoPopover', InfoPopoverComponent)
  .name

export default InfoPopoverModule
